import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";
import { LegalHero, LEGAL_TABS } from "@/components/legal/LegalHero";
import type { LegalTabId } from "@/components/legal/LegalHero";
import { LegalContent } from "@/components/legal/LegalContent";

export function LegalPage() {
  const location = useLocation();
  const hashTab = location.hash.replace("#", "") as LegalTabId;
  const [activeTab, setActiveTab] = useState<LegalTabId>(
    LEGAL_TABS.some((t) => t.id === hashTab) ? hashTab : "privacy",
  );

  useEffect(() => {
    const h = location.hash.replace("#", "") as LegalTabId;
    if (LEGAL_TABS.some((t) => t.id === h)) {
      setActiveTab(h);
      window.scrollTo(0, 0);
    }
  }, [location.hash, location.key]);

  const handleTabChange = (tab: LegalTabId) => {
    setActiveTab(tab);
    window.history.replaceState(null, "", `/legal#${tab}`);
  };

  const activeLabel = LEGAL_TABS.find((t) => t.id === activeTab)?.label ?? "Legal";

  return (
    <>
      <PageMeta
        title={`${activeLabel} | COSX`}
        description={`${activeLabel} for COSX. Privacy, terms, and policies that govern your use of the COSX platform.`}
        path="/legal"
      />

      <LegalHero activeTab={activeTab} onTabChange={handleTabChange} />
      <LegalContent activeTab={activeTab} />
    </>
  );
}
